import { createRouter, createWebHistory, RouteLocationNormalizedGeneric } from 'vue-router'
import { Action, Actor, enrollmentTracking } from './Integrations/Tracking'
import { useEligibilitySubmissionStore } from './Stores/eligibilitySubmission'
import { useQuestionStore } from './Stores/question'
import Campaign from './Views/Campaign.vue'
import Continue from './Views/Continue.vue'
import Error from './Views/Error.vue'
import Home from './Views/Home.vue'

const router = createRouter({
    history: createWebHistory('/submission'),
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
        },
        {
            path: '/campaigns/:uuid',
            name: 'campaign',
            component: Campaign,
            props: true,
        },
        {
            path: '/continue/:uuid',
            name: 'continue',
            component: Continue,
            props: true,
        },
        {
            path: '/renovation-categories',
            name: 'renovation-categories.index',
            component: () => import('./Views/RenovationCategories/Index.vue'),
        },
        {
            path: '/renovation-categories/:uuid?/questions', // pre-qualification questions
            name: 'renovation-categories.questions',
            component: () => import('./Views/RenovationCategories/Questions.vue'),
            props: true,
        },
        {
            path: '/renovation-categories/techniques',
            name: 'renovation-categories.techniques.index',
            component: () => import('./Views/RenovationCategories/Techniques.vue'),
        },
        {
            path: '/techniques/:uuid',
            name: 'techniques.show',
            component: () => import('./Views/Techniques/Show.vue'),
            props: true,
            meta: { showNavigationHeader: false },
        },
        {
            path: '/techniques/:uuid/questions',
            name: 'techniques.questions',
            component: () => import('./Views/Techniques/Questions.vue'),
            props: true,
        },
        {
            path: '/personal-details',
            name: 'personal-details',
            component: () => import('./Views/PersonalDetails.vue'),
        },
        {
            path: '/business-details',
            name: 'business-details',
            component: () => import('./Views/BusinessDetails.vue'),
        },
        {
            path: '/postal-code',
            name: 'postal-code',
            component: () => import('./Views/PostalCode.vue'),
            meta: { showNavigationHeader: false },
        },
        {
            path: '/result',
            name: 'result',
            component: () => import('./Views/Result.vue'),
        },
        {
            path: '/address',
            name: 'address',
            component: () => import('./Views/Address.vue'),
        },
        {
            path: '/contact-details',
            name: 'contact-details',
            component: () => import('./Views/ContactDetails.vue'),
        },
        {
            path: '/company-details',
            name: 'company-details',
            component: () => import('./Views/CompanyDetails.vue'),
        },
        {
            path: '/success',
            name: 'success',
            component: () => import('./Views/Success.vue'),
            meta: { requiresGlobalState: true },
        },
        {
            path: '/unqualified',
            name: 'unqualified',
            component: () => import('./Views/Unqualified.vue'),
        },
        {
            path: '/error',
            name: 'error',
            component: Error,
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        return savedPosition || { top: 0 }
    },
})

router.beforeEach((to: RouteLocationNormalizedGeneric) => {
    const eligibilitySubmissionStore = useEligibilitySubmissionStore()

    if (to.meta.requiresGlobalState && !eligibilitySubmissionStore.hasStateFilled) {
        return { name: 'error' }
    }
})

router.afterEach((to) => {
    const questionStore = useQuestionStore()

    const matchingTechnique =
        to.params?.uuid &&
        questionStore.techniques.find((technique) => technique.id === to.params.uuid)

    enrollmentTracking.track(Actor.Homeowner, Action.Navigate, {
        to: to.name,
        params: { ...to.params, technique: matchingTechnique ? matchingTechnique.key : undefined },
    })
})

export default router
